import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NotificationBadge = ({ notifications, ...rest }) => (
    <div 
    className="flex items-center justify-center"
    {...rest} >
  <button
    className="inline bg-gray-200 rounded-full w-9 h-9 mx-0 flex-shrink-0"
    title="messages"
  >
    <FontAwesomeIcon className="relative left-2" icon={faEnvelope} />
    <span className="relative left-1 -top-4 inline-flex rounded-full h-4 w-4 bg-red-500"></span>
  </button>
  </div>
);

export default NotificationBadge;
